

import React, { useEffect, useState } from 'react'


const InsertLinkInput = ({ editor }) => {
    const [url, setUrl] = useState('');
    const [showInput, setShowInput] = useState(false);
    const [isSelectionLinked, setIsSelectionLinked] = useState(false);

    if (!editor) {
        return null;
    }

    const setLink = () => {
        editor.commands.setLink({ href: url });
        setUrl('');
        setShowInput(false);
    };

    const removeLink = () => { 
        editor.commands.unsetLink() 
        setUrl('');
        setShowInput(false);
    }
    
    return (
            <div> 
                { editor.isActive('link') 
                    ? ( <button onClick={removeLink} title="Remove Link">Remove Link</button>)  
                    : ( <button onClick={() => setShowInput(!showInput) } title="Add Link">Link</button> ) } 
                {showInput &&  (
                    <div>
                        <input
                            type="text"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="Enter URL"
                        />
                        <button onClick={setLink}>Apply</button>
                    </div>
                )}
        </div>
    );
};

export default InsertLinkInput;